<template>
  <!-- 移动端共用一个组件 -->
  <SuperTouchMobile v-if="vm.isMobile" />
  <!-- pc内销外销有区别就分两个组件 -->
  <SuperTouchPcZh v-else-if="lang == 'zh'" />
  <SuperTouchPc v-else />
</template>
<script>
import SuperTouchPc from './SuperTouchPc';
import SuperTouchPcZh from './SuperTouchPcZh';
import SuperTouchMobile from './SuperTouchMobile';

export default {
  inject: ['vm', 'lang'],
  components: {
    SuperTouchPc,
    SuperTouchPcZh,
    SuperTouchMobile
  }
};
</script>
